import { allEnumValues, LocationRecommendationsLevel, LocationRecommendationsLevelHelper, RecommendationsFirstLoadVisibility, RecommendationsFirstLoadVisibilityHelper, UserRight, } from '@biteinc/enums';
export const recommendationSettingsSchema = {
    // Location Model Settings
    // BITE LIFT
    recommendationsFirstLoadVisibility: {
        type: 'stringEnum',
        enum: RecommendationsFirstLoadVisibility,
        enumNameHelper: RecommendationsFirstLoadVisibilityHelper.name,
        values: RecommendationsFirstLoadVisibilityHelper.recommendationsFirstLoadVisibilityValues,
        required: true,
        displayName: 'Guest recommendation pane visibility',
        ui: 'dropdown',
        tabId: 'recommendation-settings-v2',
        writeRight: UserRight.ManageBiteLift,
    },
    recommendationsInMenuVisibility: {
        type: 'stringEnum',
        enum: RecommendationsFirstLoadVisibility,
        enumNameHelper: RecommendationsFirstLoadVisibilityHelper.name,
        values: RecommendationsFirstLoadVisibilityHelper.recommendationsInMenuVisibilityValues,
        required: true,
        displayName: 'Guest recommendation in menu visibility',
        ui: 'dropdown',
        tabId: 'recommendation-settings-v2',
        writeRight: UserRight.ManageBiteLift,
    },
    recommendationsFirstLoadHeaderImages: {
        displayName: 'Header image for guest recommendation pane',
        tabId: 'recommendation-settings-v2',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        imagePrefix: 'sections',
        forceCrop: true,
        size: {
            width: 1536,
            height: 400,
        },
        writeRight: UserRight.ManageBiteLift,
        conditions: [
            {
                field: 'recommendationsFirstLoadVisibility',
                values: [
                    RecommendationsFirstLoadVisibility.OrderHistory,
                    RecommendationsFirstLoadVisibility.PredictionsAndOrderHistory,
                ],
            },
        ],
        exclusiveTo: 'gcn',
    },
    recommendationsLevel: {
        type: 'int',
        enum: LocationRecommendationsLevel,
        enumNameHelper: LocationRecommendationsLevelHelper.name,
        values: allEnumValues(LocationRecommendationsLevel),
        required: true,
        displayName: 'Visibility level for per-item upsell',
        ui: 'dropdown',
        tabId: 'recommendation-settings-v2',
        isHidden: true,
        tooltip: {
            text: 'How prominently to show item recommendations when guests are looking at menu items.',
        },
        writeRight: UserRight.ManageBiteLift,
    },
    showUpsellAtCheckout: {
        type: 'bool',
        required: true,
        displayName: 'Show at-checkout upsell',
        tabId: 'recommendation-settings-v2',
        tooltip: {
            text: 'Show a upsell interstitial when the guest proceeds to checkout.',
        },
        writeRight: UserRight.ManageBiteLift,
    },
    upsellCountAtCheckout: {
        type: 'int',
        required: true,
        displayName: 'Number of upsell items to show at checkout',
        tabId: 'recommendation-settings-v2',
        tooltip: {
            text: 'Number of upsell items to show when the guest proceeds to checkout.',
        },
        writeRight: UserRight.ManageBiteLift,
        conditions: [
            {
                field: 'showUpsellAtCheckout',
                values: [true],
            },
        ],
    },
    showUpsellInCart: {
        type: 'bool',
        required: true,
        displayName: 'Show in-cart upsell',
        tabId: 'recommendation-settings-v2',
        tooltip: {
            text: 'Show a upsell interstitial in the tab cart when guest proceeds to checkout.',
        },
        writeRight: UserRight.ManageBiteLift,
    },
    preselectPreviouslyOrderedMods: {
        type: 'bool',
        required: true,
        displayName: 'Use previously ordered item mods as recommendations for recommended items',
        tabId: 'recommendation-settings-v2',
        tooltip: {
            text: "If selected, will show previously ordered item mods when showing a recommended item. If not, will show the item's default mods.",
        },
        defaultValue: true,
        writeRight: UserRight.ManageBiteLift,
    },
    upsellModifiers: {
        type: 'bool',
        required: true,
        displayName: 'Upsell modifiers',
        tabId: 'recommendation-settings-v2',
        tooltip: {
            text: 'When selected, will upsell modifiers set up under menu items when selected.',
        },
        defaultValue: true,
        writeRight: UserRight.ManageBiteLift,
    },
    comboUpsell: {
        displayName: 'Combo Upsell',
        type: 'object',
        isNullable: true,
        required: true,
        tabId: 'recommendation-settings-v2',
        fields: {
            showPriceDifference: {
                displayName: 'Show price difference',
                type: 'bool',
                required: true,
                defaultValue: false,
            },
            promptForComboBuilderOnAdd: {
                displayName: 'Prompt upsell for combo builder',
                type: 'bool',
                required: true,
                defaultValue: true,
            },
            maxPromptCount: {
                displayName: 'Max prompt count',
                type: 'int',
                min: 0,
                defaultValue: 0,
                required: true,
                tooltip: {
                    text: 'Set to limit how many times the guest can be asked to get a combo; 0 for no limit',
                },
            },
        },
    },
};
//# sourceMappingURL=settings_recommendations_schema.js.map